import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface GoingConcernTailoringQuestionsProps {
  onBack?: () => void;
}

export default function GoingConcernTailoringQuestions({ onBack }: GoingConcernTailoringQuestionsProps) {
  const questions: TailoringQuestion[] = [
    {
      id: "GC-1",
      question:
        "Does the management of the entity intend to liquidate the entity or to cease operations, or has no realistic alternative but to do so.",
      type: "radio",
      options: ["Yes", "No"],
    },
    {
      id: "GC-2",
      question: "Are the financial statements prepared on other than going concern basis of accounting?",
      type: "radio",
      options: ["Yes", "No"],
      condition: {
        questionId: "GC-1",
        value: "Yes",
      },
      guidance: {
        text: "If No:",
        items: [
          "If the financial statements have been prepared using the going concern basis of accounting but, in the auditor’s judgment, management’s use of the going concern basis of accounting in the preparation of the financial statements is inappropriate, the auditor shall express an adverse opinion. (SA 570:21)",
        ],
      },
    },
  ];

  return (
    <BaseTailoringQuestions
      areaName="GC"
      title="Going Concern - Tailoring Questions"
      description="Answer the following tailoring questions for Going Concern."
      questions={questions}
      onBack={onBack}
      onComplete={(answers) => {
        console.log("Going Concern tailoring answers:", answers);
      }}
    />
  );
}
